import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps, Typography } from '@mui/material';
import { useCompareContext } from '../../Context';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from '../ColumnContext';
import { ProductCardApplyNowContainer } from '../ProductCardWithStickyHeader/components/ApplyNow.container';
import { CommonSkeleton } from './components/CommonSkeleton';
import { SKELETON_APPLY_NOW_ANNOTATION, SKELETON_RATES_AND_FEES } from './constants';
type ApplyNowSkeletonProps = {
  additionalProps?: BoxProps;
  variant?: 'default' | 'compact';
};
export function ApplyNowSkeleton(t0) {
  const $ = _c(18);
  const {
    additionalProps,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const {
    anyRatesAndFeesOffer
  } = useCompareContext();
  const {
    index
  } = useCreditCardCompareColumnContext();
  const compact = variant === "compact";
  const t2 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "flex";
  let t3;
  if ($[0] !== t2) {
    t3 = {
      xs: t2,
      md: "flex"
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== additionalProps || $[3] !== t3) {
    t4 = {
      display: t3,
      flexDirection: "column",
      ...additionalProps
    };
    $[2] = additionalProps;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !compact;
  const t6 = `skeleton-apply-now-${compact ? "mobile" : "container"}`;
  let t7;
  if ($[5] !== compact) {
    t7 = <Box display="flex" justifyContent="center" alignItems="center" height="45px" {...!compact ? {
      sx: _temp
    } : {
      sx: {
        backgroundColor: "neutral.light"
      }
    }}>{!compact ? <CommonSkeleton sx={{
        width: {
          xs: "75%",
          md: "50%"
        }
      }} height="1.25rem" /> : <Typography color="white" fontSize=".8125rem" fontWeight={700} letterSpacing=".0625em">APPLY NOW</Typography>}</Box>;
    $[5] = compact;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== anyRatesAndFeesOffer || $[8] !== compact) {
    t8 = !compact && <Box display="flex" justifyContent="center" alignItems="center" flex={1} flexDirection="column"><CommonSkeleton width="75%" height={18} data-testid={SKELETON_APPLY_NOW_ANNOTATION} />{anyRatesAndFeesOffer && <CommonSkeleton width="50%" height={24} data-testid={SKELETON_RATES_AND_FEES} />}</Box>;
    $[7] = anyRatesAndFeesOffer;
    $[8] = compact;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
    t9 = <Box display="flex" flexDirection="column" gap={2} data-testid={t6}>{t7}{t8}</Box>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t9) {
    t10 = <ProductCardApplyNowContainer containerProps={t4} needsFixedHeight={t5}>{t9}</ProductCardApplyNowContainer>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}
function _temp(theme) {
  return {
    border: `1px dashed ${theme.palette.neutral.lighter}`
  };
}